export const setPWAAction = (is_PWA) => (dispatch) => {
  dispatch({
    type: "SET_IS_PWA",
    is_PWA,
  });
};